module.exports = global["jQuery"] = require("-!F:\\qsujuan\\wwwroottwo\\h海氏海诺\\haishi-hainuo\\node_modules\\expose-loader\\index.js?$!.\\jquery.js");